import Vue from 'vue';
import Vuex from 'vuex';
import {
  SAVE_ACCOUNT_TO_STATE,
  SAVE_PROFILE_TO_STATE,
  SAVE_SAVINGS_HISTORY_TO_STATE,
  UPDATE_PORTAL_HEADER_DATA,
  UPDATE_USER,
} from '@/store/types';

import Account from '@/models/Account';
import SavingsHistory from '@/models/SavingsHistory';
import Skill from '@/models/Skill';

Vue.use(Vuex);

export const storeConfig: any = {
  state: {
    portalHeaderData: {},
    profile: null,
    saverbotAccount: null,
    savingsHistory: [],
    user: null,
  },
  getters: {
    saverbotAccount: (state: any) => state.saverbotAccount as Account,
    savingsHistory: (state: any) => state.savingsHistory as SavingsHistory[],
  },
  mutations: {
    [SAVE_ACCOUNT_TO_STATE](state: any, { saverbotAccount }: any) {
      // sort skills alphabetically to keep display order consistent
      saverbotAccount.skills.sort((a: Skill, b: Skill) => a.type.localeCompare(b.type));
      state.saverbotAccount = saverbotAccount;
    },
    [SAVE_PROFILE_TO_STATE](state: any, { profile }: any) {
      state.profile = profile;
    },
    [SAVE_SAVINGS_HISTORY_TO_STATE](state: any, { savingsHistory }: any) {
      state.savingsHistory = savingsHistory;
    },
    [UPDATE_PORTAL_HEADER_DATA](state: any, data: any) {
      state.portalHeaderData = data;
    },
    [UPDATE_USER](state: any, user: any) {
      state.user = user;
    },
  },
  actions: {
    async disableAccount({ commit, state }: any, externalId: string) {
      try {
        console.log(`disabling account with external id ${externalId}`);
        const response = await Vue.axios.post(`/api/account/${externalId}/disable`);
        commit(SAVE_ACCOUNT_TO_STATE, { saverbotAccount: response.data.data });
      } catch (e) {
        console.log(e);
      }
    },
    async getProfile({ commit, state }: any, externalId: string) {
      try {
        console.log(`get profile with external id ${externalId}`);
        const response = await Vue.axios.get('/api/profile/source-system-user-id', {
          params: {
            'source-system': 'SAVERBOT',
            'source-system-user-id': externalId,
          },
        });
        commit(SAVE_PROFILE_TO_STATE, { profile: response.data.data });
      } catch (e) {
        console.log(e);
      }
    },
    async getSaverbotAccount({ commit, state }: any, externalId: string) {
      try {
        console.log(`get saverbot account with external id ${externalId}`);
        const response = await Vue.axios.get(`/api/account/${externalId}`);
        commit(SAVE_ACCOUNT_TO_STATE, { saverbotAccount: response.data.data });
      } catch (e) {
        console.log(e);
      }
    },
    async getSavingsHistory({ commit, state }: any, externalId: string) {
      try {
        console.log(`get savings history with external id ${externalId}`);
        const response = await Vue.axios.get(`/api/savings-history?externalId=${externalId}`);
        commit(SAVE_SAVINGS_HISTORY_TO_STATE, { savingsHistory: response.data.data });
      } catch (e) {
        console.log(e);
      }
    },
  },
};

export default new Vuex.Store(storeConfig);
